import { createSlice } from '@reduxjs/toolkit';
import { convertArrayToObject } from "../../helpers/common-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface TablesState {
  tablesList: any[];
  allTableData: Record<string, any>;
}

const initialState: TablesState = {
  tablesList: [],
  allTableData: {},
};

export const tablesSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    saveTablesData: (state, actions) => {
      state.tablesList = actions.payload;
    },
    saveAllTablesData: (state, actions) => {
      state.allTableData = convertArrayToObject(actions.payload, 'mid');
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const { saveTablesData, saveAllTablesData } = tablesSlice.actions;
export default tablesSlice.reducer;
